import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import '../Work.css';
import { useNavigate } from "react-router-dom";
import gif1 from "../../assets/Images/bag.GIF";
import gif2 from "../../assets/Images/hoodie.GIF";



const WorkGroupArtworks = () => {
    const navigate = useNavigate();

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-work-headings">
                <h1>Artworks and Products</h1>
                <p>These are some of the product I tried to make for our group brands</p>

                
            </div>

            <div className="line"></div>

            <div className="content-work">
                <div className="content-work-group-artwork">
                    <div className="content-work-group-artwork-text">
                    <img src={gif2}></img>
                        
                    </div>

                    <div className="content-work-group-artwork-image">
                        <img src={gif1}></img>
                    </div>
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default WorkGroupArtworks;